import React, { ReactNode } from 'react';

import { AuthContext, AuthContextType } from '@/data/contexts/AuthContext';
import { useAuthWithNotifications } from '@/data/hooks/auth';

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const {
    user,
    isAuthenticated,
    isLoading,
    authError,
    logout,
    login,
    checkPermission,
    refetch,
  } = useAuthWithNotifications();

  const contextValue: AuthContextType = {
    user,
    isAuthenticated,
    isLoading,
    authError,
    logout,
    login,
    checkPermission,
    refetch,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
